import List from '@pelckmans/elementis/components/list';

type MaterialListHeaderProps<T> = {
  title: string;
  showSelection: boolean;
  selectedMaterial: T[];
  material: T[];
  addMaterial: (material: T[]) => void;
  removeMaterial: (material: T[]) => void;
};

export default function MaterialListHeader<T = string>({
  showSelection,
  title,
  selectedMaterial,
  material,
  addMaterial,
  removeMaterial,
}: MaterialListHeaderProps<T>) {
  if (showSelection) {
    const someSelected = material.some(m => selectedMaterial.includes(m));
    const allSelected = material.every(m => selectedMaterial.includes(m));

    const onClick = () => {
      if (allSelected) {
        removeMaterial(material);
      } else {
        addMaterial(material);
      }
    };

    return (
      <List.Header
        as="checkbox"
        title={title}
        titleTag="h3"
        prominent
        checked={someSelected}
        indeterminate={someSelected && !allSelected}
        onClick={onClick}
      />
    );
  }
  return <List.Header title={title} titleTag="h3" prominent />;
}
